import React from "react";
import { Dropdown } from "primereact/dropdown";
import styled from "styled-components";

export interface SelectProps {
  value: any;
  options: Array<any>;
  isMobile?: boolean;
  onSelect: (value: any) => void;
  placeholder: string;
}

const MySelect = styled(Dropdown)`
  .p-dropdown {
    background: transparent !important;
  }
  .p-dropdown-label.p-placeholder,
  .p-dropdown-label.p-inputtext,
  .p-dropdown-trigger {
    color: #dd052b;
  }
.p-dropdown-panel{
  color: #dd052b;
  border-radius: 0px 0px 5px 5px;
  border:#dd052b solid 1px;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item{
  color:#052E6D;
  &.p-highlight{
    color:#052E6D;
    background:#E6F0FF;
  }
}
`;

const Select: React.FC<SelectProps> = ({
  value,
  options,
  isMobile,
  onSelect,
  placeholder,
}) => (
  <MySelect
    style={{
      marginBottom: '2rem',
      border: "1px solid #dd052b",
      borderRadius: "5px",
      width: `${isMobile ? '100%' : '16.3rem'}`,
    }}
    value={value}
    options={options}
    onChange={(e) => onSelect(e.value)}
    placeholder={placeholder}
  />
);

export default Select;
